module.exports = __webpack_public_path__ + "fonts/font.9eceb20.woff";